/** Device-registry calls for the browser client (role: client, platform: web). */
import httpClient from '~/lib/http-client';
import type { RemoteDevice } from './protocol';

export async function registerDevice(name: string, publicKey: string): Promise<RemoteDevice> {
  const { data } = await httpClient.post<RemoteDevice>('/api/devices', {
    name,
    platform: 'web',
    role: 'client',
    publicKey,
  });
  return data;
}

export async function listDevices(): Promise<RemoteDevice[]> {
  const { data } = await httpClient.get<RemoteDevice[]>('/api/devices');
  return data;
}

export async function relayToken(deviceId: string): Promise<string> {
  const { data } = await httpClient.post<{ token: string }>(`/api/devices/${deviceId}/relay-token`);
  return data.token;
}

export async function revokeDevice(deviceId: string): Promise<void> {
  await httpClient.delete(`/api/devices/${deviceId}`);
}

export function relayUrl(): string {
  const base = (import.meta.env.VITE_API_URL as string | undefined) || window.location.origin;
  return base.replace(/^http/, 'ws').replace(/\/$/, '') + '/api/relay/ws';
}
